import { useGetProductRedirectContentQuery } from '@/redux/api/client/product';
import ErrorPage from '@/pages/ErrorPage';
import PageLoading from '@/routes/PageLoading';
import { useParams } from 'react-router-dom';

const ProductContentResolver = () => {
  const code = useParams()['code'];
  const isLegacyAspRoute = code?.toLowerCase().endsWith('.asp') ?? false;
  const { data: productLink, isLoading } = useGetProductRedirectContentQuery(code!, {
    skip: !code || isLegacyAspRoute
  });

  const url = productLink ? new URL(productLink) : undefined;
  const possibleRedirectTo = `${window.location.pathname}${window.location.search}`;

  if (isLoading) return <PageLoading />;
  if (url) {
    window.location.href = url.href;
    return null;
  }

  return <ErrorPage message={'404 Page not found'} possibleRedirectTo={possibleRedirectTo} />;
};

export default ProductContentResolver;
